export default __webpack_public_path__ + "static/media/Breeches of the Haunter in the Dark.abce7b93.jpg";